import { h, render } from 'preact'
import App from './App'
import './styles.css'

export type MountOptions = {
  apiBase?: string
  maxFileSizeMb?: number
  maxPages?: number
  onLeadCaptured?: (lead: { email: string; sessionId: string }) => void
}

const mounted = new WeakMap<Element, () => void>()

function mount(target: string | Element, options: MountOptions = {}): () => void {
  const el =
    typeof target === 'string' ? document.querySelector(target) : target
  if (!el) {
    console.warn('[SpendifiqueInvoiceSplitter] mount target not found:', target)
    return () => {}
  }
  unmount(el)

  render(h(App, { options }), el)

  const dispose = () => render(null, el)
  mounted.set(el, dispose)
  return dispose
}

function unmount(target: string | Element): void {
  const el =
    typeof target === 'string' ? document.querySelector(target) : target
  if (!el) return
  const dispose = mounted.get(el)
  if (dispose) {
    dispose()
    mounted.delete(el)
  }
}

const api = { mount, unmount, version: '0.1.0' }

declare global {
  interface Window {
    SpendifiqueInvoiceSplitter?: typeof api
  }
}

if (typeof window !== 'undefined') {
  window.SpendifiqueInvoiceSplitter = api
}

export default api
